/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  $('.sp-qa2-question').on('click', function () {
    var $currentItem = $(this).closest('.sp-qa2-item')
    var $answer = $currentItem.find('.sp-qa2-answer')
    var $icon = $currentItem.find('.sp-qa2-icon-box i')

    // 如果当前项已经打开 -> 关闭它
    if ($currentItem.hasClass('active')) {
      $answer.slideUp(300)
      $currentItem.removeClass('active')
      $icon.removeClass('fa-minus').addClass('fa-plus')
    }
    // 如果当前项是关闭的 -> 开启它 (并关闭其他项)
    else {
      // 关闭其他所有项
      $('.sp-qa2-item').removeClass('active')
      $('.sp-qa2-answer').slideUp(300)
      $('.sp-qa2-icon-box i').removeClass('fa-minus').addClass('fa-plus')

      // 开启当前项
      $currentItem.addClass('active')
      $answer.slideDown(300)
      $icon.removeClass('fa-plus').addClass('fa-minus')
    }
  })
})
document.addEventListener('DOMContentLoaded', function () {
  $('.sp-qa3-question').on('click', function () {
    var $currentItem = $(this).closest('.sp-qa3-item')
    var $answer = $currentItem.find('.sp-qa3-answer')

    if ($currentItem.hasClass('active')) {
      $answer.slideUp(300)
      $currentItem.removeClass('active')
    } else {
      $('.sp-qa3-item').removeClass('active')
      $('.sp-qa3-answer').slideUp(300)
      $currentItem.addClass('active')
      $answer.slideDown(300)
    }
  })
})
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }

  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-p1.png',
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-p2.png',
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-p3.png',
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-p4.png',
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-p5.png',
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-p6.png',
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-p7.png',

    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-b1.png',
    'https://cdn.shopify.com/s/files/1/0777/3863/9652/files/202512042-b2.png',
  ]

  new Swiper('.sp-swiper-fade-top', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
    loop: true,
  })

  // // 按钮轮播
  // new Swiper(".sp-btn-loop", {
  //   spaceBetween: 10,
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //     reverseDirection: true,
  //   },
  //   loop: true,
  // });

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  // Part6 卡片轮播 - PC端
  var p6CardSwiper = null

  /**
   * 初始化 Part6 轮播
   * 等待图片加载完成后再初始化，确保居中正确
   */
  function initP6Swiper() {
    if (p6CardSwiper) return // 避免重复初始化

    p6CardSwiper = new Swiper('.sp_pc .sp-p6-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 21,
      centeredSlides: true,
      loop: true,
      initialSlide: 0,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.sp_pc .sp-p6-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.sp_pc .sp-p6-next',
        prevEl: '.sp_pc .sp-p6-prev',
      },
    })
  }

  // 在 window.onload 后初始化 swiper，确保所有资源加载完成
  window.addEventListener('load', function () {
    // 延迟一帧确保页面渲染完成
    requestAnimationFrame(function () {
      initP6Swiper()
    })
  })

  new Swiper('.sp-swiper2-m', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.sp-swiper-btn-next-m',
      prevEl: '.sp-swiper-btn-prev-m',
    },
  })

  // Part6 移动端卡片轮播
  new Swiper('.sp_mobile .sp-p6-card-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp_mobile .sp-p6-pagination',
      clickable: true,
    },
  })

  // Part9 底部功能图走马灯 - 无缝滚动+支持手动滑动
  var p9Swiper = new Swiper('.sp-p9-bottom-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    loop: true,
    freeMode: {
      enabled: true,
      momentum: false,
    },
    speed: 3000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    grabCursor: true,
    on: {
      // 交互结束后恢复自动播放
      touchEnd: function () {
        var swiper = this
        setTimeout(function () {
          swiper.autoplay.start()
        }, 500)
      },
      // 鼠标拖拽结束后恢复
      sliderMove: function () {
        var swiper = this
        clearTimeout(swiper.autoplayResumeTimer)
      },
      touchStart: function () {
        this.autoplay.stop()
      },
    },
  })

  // 使用 CSS transition 实现更流畅的滚动
  var p9Wrapper = document.querySelector('.sp-p9-bottom-swiper .swiper-wrapper')
  if (p9Wrapper) {
    p9Wrapper.style.transitionTimingFunction = 'linear'
  }

  // PC端鼠标拖拽后恢复自动播放
  p9Swiper.el.addEventListener('mouseup', function () {
    setTimeout(function () {
      p9Swiper.autoplay.start()
    }, 500)
  })

  p9Swiper.el.addEventListener('mouseleave', function () {
    setTimeout(function () {
      p9Swiper.autoplay.start()
    }, 500)
  })

  // Part5 移动端features轮播
  new Swiper('.sp-p5-features-swiper', {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-p5-features-pagination',
      clickable: true,
    },
  })

  // Part5 移动端卡片轮播 (IP65防水 + 红外夜视)
  const p5CardsSwiper = new Swiper('.sp-p5-cards-swiper', {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.sp-p5-cards-next',
      prevEl: '.sp-p5-cards-prev',
    },
    on: {
      slideChange: function () {
        const prevBtn = document.querySelector('.sp-p5-cards-prev')
        const nextBtn = document.querySelector('.sp-p5-cards-next')
        // realIndex: 0 = 第一张, 1 = 第二张
        if (this.realIndex === 0) {
          prevBtn.classList.add('active')
          nextBtn.classList.remove('active')
        } else {
          prevBtn.classList.remove('active')
          nextBtn.classList.add('active')
        }
      },
      init: function () {
        // 初始化时设置第一张的状态
        const prevBtn = document.querySelector('.sp-p5-cards-prev')
        const nextBtn = document.querySelector('.sp-p5-cards-next')
        if (this.realIndex === 0) {
          prevBtn.classList.add('active')
          nextBtn.classList.remove('active')
        } else {
          prevBtn.classList.remove('active')
          nextBtn.classList.add('active')
        }
      },
    },
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 300,
    spaceBetween: 0,
  })
  let sptextList = ['X2', '', 'X2']

  /**
   * 计算并切换产品图片
   * 图片对应规则（共9张图片 p1-p9）：
   * - p1-p3: Schwarz（无内存卡）+ 1/2/3 kaufen
   * - p4-p6: Familienpaket（带配件）+ 1/2/3 kaufen
   * - p7-p9: Schwarz+32G（带内存卡）+ 1/2/3 kaufen
   */
  function updateProductImage() {
    let colorIndex = $('#sp-color .sp-option.active').index()
    let paketeIndex = $('#sp-pakete .sp-option.active').index()
    let rabatteIndex = $('#sp-rabatte .sp-option.active').index()

    // 处理未选中情况，默认为0
    colorIndex = colorIndex < 0 ? 0 : colorIndex
    paketeIndex = paketeIndex < 0 ? 0 : paketeIndex
    rabatteIndex = rabatteIndex < 0 ? 0 : rabatteIndex

    let imageIndex = 0

    if (colorIndex === 1) {
      // Schwarz+32G（带内存卡）: p7-p9
      imageIndex = 6 + rabatteIndex // 6, 7, 8 对应 p7, p8, p9
    } else if (paketeIndex === 1) {
      // Familienpaket（带配件）: p4-p6
      imageIndex = 3 + rabatteIndex // 3, 4, 5 对应 p4, p5, p6
    } else {
      // Schwarz + Standard-Paket: p1-p3
      imageIndex = rabatteIndex // 0, 1, 2 对应 p1, p2, p3
    }

    _swiper.slideTo(imageIndex)
  }

  // 颜色选项点击 - 切换图片
  $('#sp-color .sp-option').click(function () {
    $('#sp-color .sp-option').removeClass('active')
    $(this).addClass('active')
    updateProductImage()
  })

  // 数量选项点击
  $('#sp-num .sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    let numOptions = $(this).index()
    $('.sp-num-tip').text(sptextList[numOptions])
  })

  // 类型选项点击
  $('#sp-type .sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    let typeOptions = $(this).index()
    if (typeOptions > 0) {
      $('.sp-img-pro').show()
    } else {
      $('.sp-img-pro').hide()
    }
  })

  // Pakete选项点击
  $('#sp-pakete .sp-option').click(function () {
    $('#sp-pakete .sp-option').removeClass('active')
    $(this).addClass('active')
    updateProductImage()
  })

  // Rabatte选项点击
  $('#sp-rabatte .sp-option').click(function () {
    $('#sp-rabatte .sp-option').removeClass('active')
    $(this).addClass('active')
    updateProductImage()
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为

        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop
        let sptop = document.body.clientWidth <= 1080 ? 50 : -200

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'instant', // 直接跳转，无动画
        })
      })
    })

    // GUARANTEES 保障列跳转
    var guaranteeLinks = document.querySelectorAll('a[href^="#GUARANTEES"]')
    guaranteeLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault()
        const targetElement = document.getElementById('GUARANTEES')
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop
        let sptop = document.body.clientWidth <= 1080 ? 50 : 150

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'instant',
        })
      })
    })

    // FAQ 跳转
    var faqLinks = document.querySelectorAll('a[href^="#FAQ"]')
    faqLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault()
        const targetElement = document.getElementById('FAQ')
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop
        let sptop = document.body.clientWidth <= 1080 ? 50 : 150

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'instant',
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let prods = window.product
  function getCur() {
    let color = $('#sp-model div.active').attr('data-val')
    return prods.filter(item => item.option1 == color)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    //   price = (price + '').replace('.', ',')
    //   compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.sp-price-group .sp-row span').html(off_font)
  }
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
      changePrice()
    }
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

  // Model选项点击
  $('#sp-model .sp-option').click(function () {
    $('#sp-model .sp-option').removeClass('active')
    $(this).addClass('active')
    changePrice()
    // 切换到对应索引的图片
    let modelIndex = $(this).index()
    _swiper.slideTo(modelIndex)
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp_header').height() * $('div#root').css('zoom')
  ) {
    $('.sp_header-wrap').addClass('sp-fixed')
  } else {
    $('.sp_header-wrap').removeClass('sp-fixed')
  }

  // // 滚动添加底部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-part1").height() * $("div#root").css("zoom") -
  //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
  // ) {
  //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
  // } else {
  //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
  // }
  let spTimer = null
  let spHasShown = false // 防止重复显示

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp_header').height() * $('div#root').css('zoom')
    ) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // 滚动添加底部
    if (spHasShown) return // 已经显示就不再触发

    // 如果没有定时器，则开始计时
    if (!spTimer && $(window).scrollTop() > 800) {
      spTimer = setTimeout(function () {
        document.querySelector('.sp-btn-style2').style.display = 'flex'
        spHasShown = true // 标记为已显示
      }, 3000)
    }
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  let initNum = 0
  $(document).on('click', '.sp_add_cart', function () {
    // 购物车加购动效

    $(this).children('img').addClass('on')
    $('.sp-cart .num').show()
    setTimeout(function () {
      $(' .cart-btn').children('img').removeClass('on')
    }, 500)
    $(' .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-cart').removeClass('on')
    }, 500)

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
          })
        })
      },
      dataType: 'json',
    })

    // $("#calcNumber").val(1);

    $('.cardNum').removeClass('sp-gray')
    // handleAddToCart(initNum);

    var $activeSlide = $('.sp_product_part .swiper-slide-active')
    var $img = $activeSlide.find('.sp-img-p')

    if (!$img.length) {
      $img = $activeSlide.find('img')
    }

    if (!$img.length) return

    var flyer = $img[0].cloneNode(true)
    flyer.classList.add('sp_clone')

    $('.sp_product_part').append(flyer)
    $(flyer).css({
      width: $img[0].width,
      height: $img[0].height,
      background: '#e7e9ef',
      position: 'absolute',
      top: $img[0].offsetTop,
      left: $img.position().left,
      'z-index': 99,
      'pointer-events': 'none',
    })

    let finish
    if (document.body.clientWidth <= 1080) {
      finish = $('.sp-mobile-sticky-cart')
      if (!finish.length) {
        finish = $('.sp-btn-style2 .sp-cart')
      }
      var targetTop = $(window).scrollTop() + window.innerHeight - 150
      // 购物车在右边，目标位置设为屏幕右侧
      var targetLeft = 900

      $(flyer).animate(
        {
          top: targetTop,
          left: targetLeft,
          width: 50,
          height: 50,
          opacity: 0.3,
        },
        1000,
        'linear',
        function () {
          $(this).remove()
        }
      )
    } else {
      finish = $('.sp_pc .sp-cart')
      $(flyer).animate(
        {
          top: finish[0].offsetTop,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50,
          height: 50,
          opacity: 0.3,
        },
        500,
        'linear',
        function () {
          $(this).remove()
        }
      )
    }
  })

  // 问答
  // 手风琴交互逻辑 (新增)
  $('.sp-qa1-faq-question').on('click', function () {
    var $currentItem = $(this).parent('.sp-qa1-faq-item') // 当前点击的父级
    var $answer = $(this).next('.sp-qa1-faq-answer') // 当前的答案部分
    var $icon = $(this).find('.sp-qa1-faq-icon') // 当前的图标

    // 如果当前已经是打开的，则关闭它
    if ($currentItem.hasClass('active')) {
      $answer.slideUp()
      $currentItem.removeClass('active')
      $icon.removeClass('fa-minus').addClass('fa-plus')
    } else {
      // 如果当前是关闭的：

      // 1. 先关闭所有其他的项 (互斥效果)
      $('.sp-qa1-faq-item').removeClass('active')
      $('.sp-qa1-faq-answer').slideUp()
      $('.sp-qa1-faq-icon').removeClass('fa-minus').addClass('fa-plus')

      // 2. 展开当前项
      $currentItem.addClass('active')
      $answer.slideDown()
      $icon.removeClass('fa-plus').addClass('fa-minus')
    }
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }

  // 快速文本渐出动画 sp-ani-fast
  const graduallyListFast = document.getElementsByClassName('sp-fade-box')
  for (let graduallyFast of graduallyListFast) {
    const paragraphFast = graduallyFast.querySelectorAll('.sp-ani-fast')

    const observerAniFast = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraphFast.forEach((span, index) => {
              span.style.animation = `sp-fade-in 0.6s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 0.5}s`
            })

            observerAniFast.unobserve(graduallyFast)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAniFast.observe(graduallyFast)
  }

  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})
